import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import tw from 'twin.macro';

import lockImg from '../../assets/imgs/lock-white.png';

const Wrapper = styled.div.attrs({
  className: 'flex items-end',
})`
  .tab {
    ${tw`w-1/3 bg-black text-white p-3 border border-solid border-white text-base uppercase`}

    &:not(.selected) {
      border-left: none;
    }
    &.selected {
      ${tw`bg-white text-black border-black p-4 text-xl`}
      box-shadow: 0px -1px 3px rgba(0, 0, 0, 0.4);
    }
  }
`;

const memberships = [
  {
    key: 'base',
    label: 'Base membership',
  },
  {
    key: 'plus',
    label: 'Plus + Membership',
    locked: true,
  },
  {
    key: 'career_plus',
    label: 'Career Plus + Membership',
    locked: true,
  },
];

const Tabs = ({ current }) => {
  return (
    <div className="">
      <Wrapper>
        {memberships.map((membership) => (
          <div
            key={membership.key}
            className={cx(
              'tab flex items-center justify-center',
              membership.key === current && 'selected',
              membership.locked && 'cursor-not-allowed'
            )}
          >
            <span
              className={
                membership.key === current &&
                'border-b border-solid border-yellow px-2'
              }
            >
              {membership.label}
            </span>
            {membership.locked && (
              <img className="ml-6 w-5 h-5" src={lockImg} alt="lock" />
            )}
          </div>
        ))}
      </Wrapper>
    </div>
  );
};

export default Tabs;
